import DarkCard from "../../../../../components/card/DarkCard";
import { useTranslation } from "react-i18next";
import LordIcon from "../../../../../components/ui/LordIcon";
import { Link } from "react-router-dom";
import { Colors } from "../../../../../components/theme";
import LocationListElement from "./LocationListElement";
import {useEffect, useState} from "react";
import {locationsListAPI} from "../../../../../services/api/locations";
import {getCountriesListAPI} from "../../../../../services/api/user";

function LocationsList () {
    const { t } = useTranslation();
    const [locations, setLocations] = useState([])
    const [countries, setCountries] = useState([])

    function compareByName(a, b) {
        return a.name.localeCompare(b.name);
    }

    useEffect(() => {
        const getLocationsList = async () => {
            try {
                const response = await locationsListAPI()
                const locationsResp = response.data
                setLocations(locationsResp.sort(compareByName))
            } catch (e) {
                console.log("Failed to download locations data")
            }
            try {
                const resp_list = await getCountriesListAPI()
                const data = resp_list.data.qs.map(el => {
                    return {
                        value: el.name,
                        label: el.name,
                        pk: el.pk,
                    }
                })
                setCountries(data)
            } catch (ex) {
                console.log("Failed to download locations list.", ex);
            }
        }
        getLocationsList()
    }, [])

    return (
        <>
            <DarkCard classNames='mb-3 row'>
                <p className="m-0 p-0 breadcrumbs">
                    <Link to={'/locations'} className="edit-link">{t("menu.locations",{ ns: 'menu' })}</Link>
                </p>
            </DarkCard>

            <DarkCard classNames='mb-3 row'>

                <h1 className="mt-0 p-0">{t("location.main_page_title")}</h1> 

                <div className="row p-0">
                    <div className="col-sm-8">
                        <Link className="addGroup edit-link" to={'new'}>
                            <LordIcon url='cross' color={`${Colors.red};`} rotate='45' target='.addGroup'/>
                            <span className="ps-2">{t("common.button.add_location")}</span>
                        </Link>
                    </div>
                    <div className="col-sm-4 mt-3 mt-sm-0">
                        <input style={{width:'100%'}} placeholder="Search" disabled></input>
                    </div>
                </div>
                <div className="mt-4 p-0">
                    {locations.length > 0 ? (
                        locations.map(loc => (
                            <LocationListElement
                            key={loc.id}
                            lDetailsUrl={`location/${loc.id}`}
                            lName={loc.name}
                            lCity={loc.city}
                            lCountry={loc.country}
                            lMap={loc.map_url}
                            lNote={loc.note}
                            countries={countries}
                            />
                        ))
                    ) : (
                        <p className="text-center mt-2">{t("location.no_data")}</p>
                    )}
                </div>
            </DarkCard>

        </>
    )
};


export default LocationsList;